import { render, staticRenderFns } from "./ThirtyDay.vue?vue&type=template&id=24f62560&lang=pug"
import script from "./ThirtyDay.vue?vue&type=script&lang=js"
export * from "./ThirtyDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports